import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';
import { Helmet } from 'react-helmet';
import commonActions from '../common/commonActions';

import ClaimForm from './ClaimForm';
import { Page, PageContent, PageHeader } from '../components/common';

interface Props {
	actions: any;
}
interface State {
	form: {
		name: string;
		phone: string;
		email: string;
		policyNumber: string;
		deceasedName: string;
		comments: string;
	};
	loading: boolean;
}
class MakeAClaimPage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = this.getInitialState();
	}

	getInitialState = () => {
		return {
			form: {
				name: '',
				phone: '',
				email: '',
				policyNumber: '',
				deceasedName: '',
				comments: ''
			},
			loading: false
		};
	}

	onFormChange = (e: any) => {
		const form = { ...this.state.form, [e.target.name]: e.target.value };
		this.setState({ form });
	}

	onPhoneKeyUp = (e: any) => {
		let phone = e.target.value;
		phone = phone
			.match(/\d*/g)
			.join('')
			.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
			.slice(1)
			.join('-')
			.replace(/-*$/g, '');

		const form = { ...this.state.form, phone };
		this.setState({ form });
	}

	onSubmit = () => {
		this.setState({ loading: true });
		this.props.actions.fileAClaim(this.state.form)
			.then(() => {
				this.setState(this.getInitialState());
				toastr.success('Your form has been sent! We will contact you as soon as we can.');
			});
	}

	render() {
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`If you need to make a life insurance claim, fill out our quick easy to use form and Mosaic Life will help you promptly. `}
					/>
					<title>Make a Claim | Mosaic Life</title>
				</Helmet>
				<PageContent>
					<div className="mb-4">
						<PageHeader title="Make a Claim" />
						<p>
							We're sorry for your loss.
						</p>
						<p>
							Please fill out the form below and we will contact you shortly to begin the
							claim process. We aim to respond within 1 business day.
						</p>
						<p>
							If you have questions about a claim, call us at <a href="tel:1-855-643-6945">1-855-643-6945</a>.
						</p>
					</div>
					<ClaimForm
						loading={this.state.loading}
						form={this.state.form}
						onFormChange={this.onFormChange}
						onPhoneKeyUp={this.onPhoneKeyUp}
						onSubmit={this.onSubmit}
					/>
				</PageContent>
			</Page>
		);
	}
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...commonActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(null, mapDispatchToProps)(MakeAClaimPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/claim/MakeAClaimPage.tsx